import React, { useState, useContext, useEffect } from "react";
import { shopify_url } from 'config'

import { 
  Link,
  TextField,
  Box,
  Button,
  InputAdornment,
  Typography
} from '@mui/material';

import { AuthContext } from 'components';

export const IntegrationShopify = (props) => {
  const { accountIntegrations } = useContext(AuthContext);
  const [ shop, setShop ] = useState("")
  const [ showHowTo, setShowHowTo ] = useState(false)
  const [ error, setError ] = useState(false)

  useEffect(() => {
    if (accountIntegrations && !accountIntegrations?.shopify_v2) {
      let prefilled_domain = `${accountIntegrations?.shopify_v1?.domain || ''}`?.replace('.myshopify.com', '')
      setShop(prefilled_domain)
    }
  }, [accountIntegrations])

  const handleClick = () => {
    if (shop) {
      window.location.href = `${shopify_url}/login/?shop=${shop}&customer_portal=${window.location.origin}`
    }
  }

  return (
    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', mt: 4 }}>
      <Typography sx={{ width: '100%' }} variant="h5">Add Shopify Store</Typography>
      <TextField
        id="add-shopify-store"
        key="add-shopify-store"
        sx={{ 
          maxWidth: 400, 
          width: '70%',
          mr: '20px'
        }}
        InputLabelProps={{ shrink: true }}
        error={error}
        // helperText={error || ""}
        variant='standard'
        label={error || ""}
        value={shop}
        FormHelperTextProps={{
          style: {
            background: 'red',
          }
        }}
        InputProps={{
          disableUnderline: true,
          inputProps: {
            style: { 
              textAlign: "right", 
              fontSize: '1rem', 
              paddingRight: 0,
              paddingBottom: 0,
              marginBottom: '8px',
              borderBottom: '1px solid black',
            },
          },
          endAdornment: <InputAdornment sx={{ marginLeft: 0 }} position="end">.myshopify.com</InputAdornment>,
        }}
        onFocus={() => {
          setError(false)
        }}
        onBlur={(e) => {
          const regex = new RegExp('^[a-zA-Z0-9\-]*$')
          if (!regex.test(e.target.value)) {
            setError('Shopify domain can only contain letters, numbers and dashes')
          } else {
            setError(false)
          }
        }}
        onChange={(e) => { 
          // if (onChange) { onChange(e.target.value) }
          setShop(e.target.value)
        }}
      />
      <Button sx={{ maxWidth: 200, padding: '8px 16px', marginBottom: '2px' }} variant={shop?'contained':'outlined'} color="secondary" disabled={!shop} onClick={handleClick}>Add Store</Button>
      <Box sx={{ width: '100%' }}>
        { !showHowTo ? (
          <Link onClick={() => { setShowHowTo(true) }} fontSize={'12px'} underline="none" href="#">How to find your myshopify.com domain name</Link>
        ) : (
          <Box>
            <img style={{ maxWidth: '400px' }} src="/shopify_domain.png" />
            <Typography>
              On your Shopify home screen, copy the text that appears after "/store/" and before the next "/"
            </Typography>
          </Box>
        )}
      </Box>
    </Box>
  );
};
